import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
gsap.registerPlugin(MotionPathPlugin);

export default class ProcessAnimationPartner {
	constructor(elm) {
		this.elm = elm;

		this.dot1 = this.elm.querySelector('[data-process-animation-partner-dot1]');
		this.dot2 = this.elm.querySelector('[data-process-animation-partner-dot2]');

		this.dot3 = this.elm.querySelector('[data-process-animation-partner-dot3]');
		this.dot4 = this.elm.querySelector('[data-process-animation-partner-dot4]');
		this.dot5 = this.elm.querySelector('[data-process-animation-partner-dot5]');
		this.dot6 = this.elm.querySelector('[data-process-animation-partner-dot6]');
		this.dot7 = this.elm.querySelector('[data-process-animation-partner-dot7]');
		this.dot8 = this.elm.querySelector('[data-process-animation-partner-dot8]');
		this.dot9 = this.elm.querySelector('[data-process-animation-partner-dot9]');
		this.dot10 = this.elm.querySelector('[data-process-animation-partner-dot10]');
		this.dot11 = this.elm.querySelector('[data-process-animation-partner-dot11]');
		this.dot12 = this.elm.querySelector('[data-process-animation-partner-dot12]');
		this.dot13 = this.elm.querySelector('[data-process-animation-partner-dot13]');
		this.dot14 = this.elm.querySelector('[data-process-animation-partner-dot14]');
		this.dot15 = this.elm.querySelector('[data-process-animation-partner-dot15]');
		this.dot16 = this.elm.querySelector('[data-process-animation-partner-dot16]');
		this.dot17 = this.elm.querySelector('[data-process-animation-partner-dot17]');
		this.dot18 = this.elm.querySelector('[data-process-animation-partner-dot18]');

		this.dot19 = this.elm.querySelector('[data-process-animation-partner-dot19]');
		this.dot20 = this.elm.querySelector('[data-process-animation-partner-dot20]');
		this.dot21 = this.elm.querySelector('[data-process-animation-partner-dot21]');
		this.dot22 = this.elm.querySelector('[data-process-animation-partner-dot22]');

		this.tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 0,
		});

		// In
		this.tl.from(
			this.dot1,
			{
				duration: 8,
				x: -80,
				ease: 'sine.inOut',
			},
			0
		);

		this.tl.from(
			this.dot2,
			{
				duration: 7,
				x: 80,
				ease: 'power1.inOut',
			},
			0
		);

		this.tl.from(
			this.dot3,
			{
				duration: 6,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: 40 },
						{ x: -20, y: 10 },
						{ x: -30, y: 20 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot4,
			{
				duration: 5,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: -10 },
						{ x: 12, y: -20 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot5,
			{
				duration: 4,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -20, y: 10 },
						{ x: -15, y: 20 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot6,
			{
				duration: 8,
				ease: 'power1.inOut',
				motionPath: {
					path: [
						{ x: 0, y: -10 },
						{ x: -40, y: -20 },
						{ x: -50, y: 10 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot7,
			{
				duration: 7,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: 30 },
						{ x: 25, y: 60 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot8,
			{
				duration: 6,
				ease: 'power1.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: 10 },
						{ x: 5, y: -20 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot9,
			{
				duration: 5,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -10, y: -10 },
						{ x: 5, y: -30 },
					],
					curviness: 2,
				},
			},
			2
		);

		this.tl.from(
			this.dot10,
			{
				duration: 4,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: -10 },
						{ x: 55, y: -20 },
					],
					curviness: 2,
				},
			},
			4
		);

		this.tl.from(
			this.dot11,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: 40 },
						{ x: 30, y: 50 },
						{ x: 50, y: 50 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot12,
			{
				duration: 7,
				ease: 'power1.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -10, y: -30 },
						{ x: -40, y: -40 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot13,
			{
				duration: 6,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -5, y: 5 },
						{ x: -10, y: -5 },
						{ x: -7, y: 4 },
						{ x: -3, y: -8 },
					],
					curviness: 2,
				},
			},
			1
		);

		this.tl.from(
			this.dot14,
			{
				duration: 5,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 5, y: 3 },
						{ x: 7, y: 2 },
						{ x: 4, y: 4 },
					],
					curviness: 2,
				},
			},
			1
		);

		this.tl.from(
			this.dot15,
			{
				duration: 4,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -40, y: 0 },
						{ x: -40, y: 20 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot16,
			{
				duration: 8,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -10, y: -10 },
						{ x: 5, y: -30 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot17,
			{
				duration: 7,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: 40 },
						{ x: -20, y: 10 },
						{ x: -30, y: 20 },
					],
					curviness: 2,
				},
			},
			1
		);

		this.tl.from(
			this.dot18,
			{
				duration: 6,
				ease: 'power1.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: -10 },
						{ x: 12, y: -20 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot19,
			{
				duration: 5,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 30, y: 10 },
						{ x: 25, y: 20 },
					],
					curviness: 2,
				},
			},
			1
		);

		this.tl.from(
			this.dot20,
			{
				duration: 8,
				ease: 'none',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -40, y: 30 },
						{ x: -50, y: 10 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot21,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: -20 },
						{ x: 25, y: -40 },
					],
					curviness: 2,
				},
			},
			0
		);

		this.tl.from(
			this.dot22,
			{
				duration: 7,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: 10 },
						{ x: 5, y: -20 },
					],
					curviness: 2,
				},
			},
			0
		);

		// Out
		this.tl.to(
			this.dot1,
			{
				duration: 8,
				x: -80,
				ease: 'sine.inOut',
			},
			8
		);

		this.tl.to(
			this.dot2,
			{
				duration: 8,
				x: 80,
				ease: 'power2.inOut',
			},
			8
		);

		this.tl.to(
			this.dot3,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: 40 },
						{ x: -20, y: 10 },
						{ x: -30, y: 20 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot4,
			{
				duration: 8,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: -10 },
						{ x: 12, y: -20 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot5,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -20, y: 10 },
						{ x: -15, y: 20 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot6,
			{
				duration: 8,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: -10 },
						{ x: -40, y: -20 },
						{ x: -50, y: 10 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot7,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: 30 },
						{ x: 25, y: 60 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot8,
			{
				duration: 8,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: 10 },
						{ x: 5, y: -20 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot9,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -10, y: -10 },
						{ x: 5, y: -30 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot10,
			{
				duration: 8,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: -10 },
						{ x: 55, y: -20 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot11,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: 40 },
						{ x: 30, y: 50 },
						{ x: 50, y: 50 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot12,
			{
				duration: 4,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -10, y: -30 },
						{ x: -40, y: -40 },
					],
					curviness: 2,
				},
			},
			10
		);

		this.tl.to(
			this.dot13,
			{
				duration: 6,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -5, y: 5 },
						{ x: -10, y: -5 },
						{ x: -7, y: 4 },
						{ x: -3, y: -8 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot14,
			{
				duration: 7,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 5, y: 3 },
						{ x: 7, y: 2 },
						{ x: 4, y: 4 },
					],
					curviness: 2,
				},
			},
			7
		);

		this.tl.to(
			this.dot15,
			{
				duration: 5,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -40, y: 0 },
						{ x: -40, y: 20 },
					],
					curviness: 2,
				},
			},
			11
		);

		this.tl.to(
			this.dot16,
			{
				duration: 6,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -10, y: -10 },
						{ x: 5, y: -30 },
					],
					curviness: 2,
				},
			},
			10
		);

		this.tl.to(
			this.dot17,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: 40 },
						{ x: -20, y: 10 },
						{ x: -30, y: 20 },
					],
					curviness: 2,
				},
			},
			6
		);

		this.tl.to(
			this.dot18,
			{
				duration: 7,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 0, y: -10 },
						{ x: 12, y: -20 },
					],
					curviness: 2,
				},
			},
			7
		);

		this.tl.to(
			this.dot19,
			{
				duration: 6,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 30, y: 10 },
						{ x: 25, y: 20 },
					],
					curviness: 2,
				},
			},
			12
		);

		this.tl.to(
			this.dot20,
			{
				duration: 6,
				ease: 'sine.in',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: -40, y: 30 },
						{ x: -50, y: 10 },
					],
					curviness: 2,
				},
			},
			10
		);

		this.tl.to(
			this.dot21,
			{
				duration: 8,
				ease: 'sine.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: -20 },
						{ x: 25, y: -40 },
					],
					curviness: 2,
				},
			},
			8
		);

		this.tl.to(
			this.dot22,
			{
				duration: 4,
				ease: 'power2.inOut',
				motionPath: {
					path: [
						{ x: 0, y: 0 },
						{ x: 10, y: 10 },
						{ x: 5, y: -20 },
					],
					curviness: 2,
				},
			},
			10
		);
	}
}
